import handlebars from "handlebars";

handlebars.registerHelper("increment", function (value) {
    return parseInt(value) + 1;
});

handlebars.registerHelper("for", function (from, to, incr, block) {
    var accum = "";
    for (var i = from; i < to; i += incr) accum += block.fn(i);
    return accum;
});

handlebars.registerHelper("ifCond", function (v1, v2, options) {
    if (v1 === v2) {
        return options.fn(this);
    }
    return options.inverse(this);
});

handlebars.registerHelper("gt", function (a, b) {
    var next = arguments[arguments.length - 1];
    return a > b ? next.fn(this) : next.inverse(this);
});

handlebars.registerHelper("lt", function (a, b) {
    var next = arguments[arguments.length - 1];
    return a < b ? next.fn(this) : next.inverse(this);
});

handlebars.registerHelper("adjustPos", function (baseValue, zoomScale) {
    const center = 50;
    const numericValue = parseFloat(String(baseValue).replace("%", ""));

    const diff = numericValue - center;
    const adjusted = numericValue - diff * (zoomScale - 1);

    return adjusted.toFixed(6) + "%";
});

const compile = (htmlTemplate, data) => {
    const template = handlebars.compile(htmlTemplate);
    return template(data);
};

export default compile;
